import type React from "react";
import { ReactComponent as Svg } from "./assets/bet-single.svg";
import * as styles from "./Icon.module.scss";

type BetSingleProps = React.SVGProps<SVGSVGElement>;

export const BetSingle = ({ className, ...props }: BetSingleProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
